import { CheckCircle } from 'lucide-react'
import { usePortal } from '@/contexts/PortalContext'
import { TemplateSection } from '@/lib/portalApi'

export function ConfirmationScreen() {
  const { data, answers, submittedAt, isComplementMode } = usePortal()

  const sections: TemplateSection[] = (data?.template.sections ?? [])
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  const submittedAtDisplay = submittedAt
    ? new Date(submittedAt).toLocaleString('fr-FR')
    : 'Soumis récemment'

  function displayValue(fieldId: string): string {
    const val = answers[fieldId]
    if (val === null || val === undefined || String(val).trim() === '') return '—'
    return String(val)
  }

  return (
    <div className="w-full">
      {/* Icône de confirmation */}
      <div className="flex flex-col items-center text-center mb-8">
        <CheckCircle
          className="w-16 h-16 mb-4"
          style={{ color: 'var(--supplier-primary)' }}
        />
        <h1 className="text-2xl font-bold text-foreground mb-2">
          {isComplementMode
            ? 'Complément envoyé'
            : `✓ Vos données ont été transmises à ${data?.organization.name ?? '…'}`}
        </h1>
        {isComplementMode && (
          <p className="text-sm text-muted-foreground mb-1">
            Votre réponse complémentaire a été transmise à {data?.organization.name ?? '…'}. Vous pouvez fermer cette page.
          </p>
        )}
        <p className="text-sm text-muted-foreground">
          Soumis le {submittedAtDisplay}
        </p>
      </div>

      {/* Récapitulatif compact des données soumises */}
      <div className="space-y-6 border rounded-lg p-6 bg-card">
        {sections.map((section) => (
          <div key={section.id}>
            <h3 className="font-semibold text-sm text-foreground mb-3 border-b pb-1">
              {section.title}
            </h3>
            <div className="space-y-2">
              {section.fields.map((field) => (
                <div key={field.id} className="flex justify-between gap-4 text-sm">
                  <span className="text-muted-foreground">{field.label}</span>
                  <span className="font-medium text-foreground text-right break-words max-w-[55%]">
                    {displayValue(field.id)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Message de clôture */}
      <p className="text-center text-sm text-muted-foreground mt-8">
        Vous pouvez fermer cet onglet. Votre réponse a été enregistrée.
      </p>
    </div>
  )
}
